function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;stroke:#5cc3b6;stroke-linecap:round;stroke-linejoin:round;stroke-width:50px;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "Layer_1-2",
  "data-name": "Layer 1"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M175.86,371.05,163.54,379A59.25,59.25,0,0,0,146,460.66L265.26,645.28a59.23,59.23,0,0,0,81.67,17.54l12.28-7.94a59.19,59.19,0,0,0,17.55-81.64L257.49,388.6A59.22,59.22,0,0,0,175.86,371.05Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M64.29,443.15,52,451.09a59.22,59.22,0,0,0-17.58,81.64l119.3,184.64a59.2,59.2,0,0,0,81.64,17.55L247.64,727a59.22,59.22,0,0,0,17.55-81.66L145.92,460.69A59.21,59.21,0,0,0,64.29,443.15Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M570.48,537.18,679.75,113a67.68,67.68,0,0,0-48.41-82.3l-13.73-3.59a67.76,67.76,0,0,0-82.33,48.41L422.34,464"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M239.69,370.8,160,113.06A67.76,67.76,0,0,1,208.4,30.71l13.76-3.54a67.72,67.72,0,0,1,82.33,48.4L422.32,464"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M359.54,928.61C371.88,805.81,536,751.2,536,751.2l13.57-57.08-77.67-53.91c-30.48-24.76-34.28-66.47-14-102.8,15.91-28.44,48.88-17,48.88-17s145.49,35.71,176.93,56.4c67.52,44.38,18,213.61-9.45,265.41s-104.65,211.16-104.65,211.16l-10,71.69"
}), /*#__PURE__*/React.createElement("polyline", {
  className: "cls-1",
  points: "27.23 516.94 45.56 824.93 149.8 1053.39"
})));

function SvgRight2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 742.68 1150.07",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgRight2);
export default __webpack_public_path__ + "static/media/right-2.5e1f3279.svg";
export { ForwardRef as ReactComponent };